import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-primary text-white py-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-6">
              <img src="/logo-white.png" alt="Get Logo Trademarked" className="h-12 w-auto" />
            </div>
            <p className="text-white/70 leading-relaxed">
              Protecting your intellectual property with professional trademark and copyright services across the USA.
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Services</h3>
            <ul className="space-y-3">
              <li><Link to="/trademark-registration" className="text-white/70 hover:text-white transition-colors">Trademark Registration</Link></li>
              <li><Link to="/copyright-registration" className="text-white/70 hover:text-white transition-colors">Copyright Registration</Link></li>
              <li><Link to="/company-formation" className="text-white/70 hover:text-white transition-colors">Company Formation</Link></li>
              <li><Link to="/trademark-search" className="text-white/70 hover:text-white transition-colors">Trademark Search</Link></li>
              <li><Link to="/amazon-brand-registry" className="text-white/70 hover:text-white transition-colors">Amazon Brand Registry</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Legal</h3>
            <ul className="space-y-3">
              <li><Link to="/privacy-policy" className="text-white/70 hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms-conditions" className="text-white/70 hover:text-white transition-colors">Terms & Conditions</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="h-5 w-5 text-accent mt-0.5" />
                <a href="mailto:Info@getlogotrademarked.com" className="text-white/70 hover:text-white transition-colors">Info@getlogotrademarked.com</a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="h-5 w-5 text-accent mt-0.5" />
                <a href="tel:+11231234567" className="text-white/70 hover:text-white transition-colors">+1 (123) 123-4567</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-accent mt-0.5" />
                <span className="text-white/70">468 N Camden Dr,<br />Beverly Hills, CA 90210</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center text-white/50 text-sm">
          <p>© {new Date().getFullYear()} Get Logo Trademarked. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};